import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'

const StyledList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  text-align: left;

  ${({ fromCms }) =>
    fromCms &&
    css`
      margin-top: 48px;
    `}
`

const StyledItem = styled.li`
  margin-bottom: ${({ width }) => (width !== '100' ? '24px' : '16px')};
  padding-left: 48px;
  position: relative;
  width: 100%;

  ${({ theme }) => theme.media.desktop} {
    width: ${({ width }) => width}%;
  }
`

const StyledCount = styled.span`
  align-items: center;
  border-radius: 50%;
  border: 1px solid rgba(192, 36, 40, 0.16);
  color: ${({ theme }) => theme.colors.red};
  display: flex;
  font-size: 0.875em;
  height: 32px;
  justify-content: center;
  margin-right: 16px;
  position: absolute;
  transform: translateX(-48px);
  width: 32px;
`

const StyledTitle = styled.div`
  color: ${({ theme }) => theme.colors.greyParagraphColor};
  font-size: 0.875em;
  font-weight: 500;
  line-height: 1.71;
  margin-bottom: 4px;
`

const StyledSubtitle = styled.div`
  color: ${({ theme }) => theme.colors.greySubtitleColor};
  font-size: 0.875em;
  line-height: 1.71;

  & a {
    color: #4e5d78;
    display: inline-block;

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`

const NumberedList = ({ items, cmsData }) => {
  const numberItems = cmsData ? cmsData.items.map(item => item.fields) : items

  return (
    <StyledList fromCms={!!cmsData}>
      {numberItems.map(({ id, name, text }, index) => {
        const subtitle = (typeof text === 'object' ? text.text : text) || ''

        return (
          <StyledItem
            width={cmsData ? cmsData.width : '100'}
            key={id || `nl-${index}`}
          >
            <StyledCount>{index + 1}</StyledCount>
            <StyledTitle>{name}</StyledTitle>
            <StyledSubtitle>
              <ReactMarkdown source={subtitle} />
            </StyledSubtitle>
          </StyledItem>
        )
      })}
    </StyledList>
  )
}

NumberedList.propTypes = {
  items: PropTypes.array,
}

export default NumberedList
